import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'

import { Router } from '@angular/router'
import { NotificationService } from '../../services/notification.service'

@Component({
  selector: 'bmcore-global-search-block',
  templateUrl: './bmcore-global-search-block.component.html',
  styleUrls: ['./bmcore-global-search-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreGlobalSearchBlockComponent implements OnInit {
  search = ''

  constructor(
    private notificationService: NotificationService,
    private router: Router
  ) {}

  ngOnInit(): void {}

  changeSearchValue(e: Event) {
    this.search = (e.currentTarget as HTMLInputElement).value
  }

  findTrackHandler() {
    if (this.search.trim()) {
      this.router.navigate(['/catalog'], { queryParams: { beat: this.search } })
    } else {
      this.notificationService.handleInfo('Please enter the name of the track')
    }
  }
}
